import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    // height: '100vh',
    // overflow: 'auto',
    '& :hover': {
      // color: colors.black1,
      opacity: 1,
    },
    '& .Mui-selected': {
      color: `${Colors.primary} !important`,
      textTransform: 'none !important',
      fontWeight: '700 !important',
    },
    '& .Mui-focusVisible': {
      // backgroundColor: `${colors.black1} !important`,
    },
    '& .MuiTab-root': {
      textTransform: 'none !important',
      fontSize: 14,
      fontWeight: '400',
      paddingBottom: '-0px !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Colors.primary,
      height: 1,
    },
  },
};

export default styles;
